/** Non-Time dimension ids on the block (same as BuilderModeDataTableOpz fetch params). */
export function getBlockNonTimeDimensionIds(plannerBlock: any): string {
  if (!plannerBlock?.dimensions) return '';
  return plannerBlock.dimensions
    .filter((item: any) => item.name !== 'Time')
    .map((item: any) => item.id)
    .join(', ');
}

export function blockHasNonTimeDimensions(plannerBlock: any): boolean {
  return getBlockNonTimeDimensionIds(plannerBlock).length > 0;
}

function hasPopulatedDimItemData(dimItemData: any): boolean {
  if (!dimItemData) return false;
  if (Array.isArray(dimItemData)) return dimItemData.length > 0;
  if (typeof dimItemData === 'object') return Object.keys(dimItemData).length > 0;
  return false;
}

/**
 * True when any existing row in local table/Redux outputs already uses dimensional breakdown
 * (chevron parent/child or dim_item_data), matching what Opz shows via indicatorValues sync.
 */
export function hasDimensionalIndicatorsInTable(existingRows: any[]): boolean {
  if (!existingRows?.length) return false;

  return existingRows.some(
    (row) =>
      row?.chevronType === 'parent' ||
      row?.chevronType === 'child' ||
      (row?.chevronType !== 'child' &&
        !row?.parentId &&
        hasPopulatedDimItemData(row?.dim_item_data)),
  );
}

function zeroTotalValuesLike(template: any[] | undefined, indicatorHeaders: { name: string }[]) {
  if (template?.length) {
    return template.map((entry) => ({
      ...entry,
      value: 0,
      value2: entry?.value2 !== undefined ? 0 : entry?.value2,
    }));
  }
  return indicatorHeaders.map((header) => ({
    name: header.name,
    value: 0,
  }));
}

/**
 * Builds dim_item_data for a new indicator from an existing dimensional indicator in the table.
 */
export function buildDimItemDataTemplateFromExisting(
  existingRows: any[],
  indicatorHeaders: { name: string }[],
): any[] | null {
  const children = existingRows.filter((row) => row?.chevronType === 'child');
  if (children.length > 0) {
    return children.map((child) => ({
      name: child.name,
      value: zeroTotalValuesLike(child.total_values, indicatorHeaders),
      total_values: zeroTotalValuesLike(child.total_values, indicatorHeaders),
    }));
  }

  const parentWithDim = existingRows.find(
    (row) =>
      row?.chevronType !== 'child' && !row?.parentId && hasPopulatedDimItemData(row?.dim_item_data),
  );
  if (!parentWithDim?.dim_item_data) return null;

  const dimItems = Array.isArray(parentWithDim.dim_item_data)
    ? parentWithDim.dim_item_data
    : Object.values(parentWithDim.dim_item_data || {});

  return dimItems.map((item: any) => {
    const valueTemplate = item?.value ?? item?.total_values;
    return {
      name: item?.name ?? item?.id,
      value: zeroTotalValuesLike(valueTemplate, indicatorHeaders),
      total_values: zeroTotalValuesLike(item?.total_values ?? valueTemplate, indicatorHeaders),
    };
  });
}
